import { CNavLink } from '../CNavLink'
import { useActiveLeague } from "../../hooks/useActiveLeague"
import TutorialTooltip from '../common/TutorialTooltip';

function MatchPageNav({id, teamOneId, isSummaryEnabled = false, leagueSlug}) {
  const { activeLeague } = useActiveLeague();
  const baseSlug = leagueSlug || activeLeague?.slug;
  const base = baseSlug ? `/${baseSlug}` : "";

  return (
      <div className="onpage-nav-block">
          <ul className="onpage-nav">
                <TutorialTooltip
                  id="watch-game-tooltip"
                  title="Watch game"
                  description="Click on match to watch the game."
                  className="f-bottom"
                />

                <TutorialTooltip
                  id="match-summary-tooltip"
                  title="Match summary"
                  description="The match summary will be generated after the game has been played. Here you can view the full match report and player stats."
                  className="f-left"
                />

              <CNavLink to={`${base}/match/${id}/lineups`} active={[`/match/${id}/lineups`]}>
                  Lineups
              </CNavLink>
              <CNavLink to={`${base}/match/${id}/match`} active={[`/match/${id}/match`]}>
                  Match
              </CNavLink>
              <CNavLink to={`${base}/match/${id}/summary/${teamOneId}`} active={[`/match/${id}/summary`]} disabled={!isSummaryEnabled}>
                  Summary
              </CNavLink>
          </ul>
      </div>
  )
}

export {MatchPageNav}
